<div style="padding: 12px; text-align: center">Verifying link...</div>
<lib-preloader [loading]="loading"></lib-preloader>
